import React from 'react';
import { ListWrapper } from '../ListWrapper';
import { useMonthlyOrdersFilterParams } from '../../hooks';
import { cleanMonthlyRelationSelectAndStore, getMonthlyOrdersListRelationSelect } from '../../middleware';
import { Catcher } from '../Catcher';
import { MonthlyOrdersListTable } from './Components/MonthlyOrdersListTable';

export const MonthlyOrdersList: React.FC = () => {
    const filterParams = useMonthlyOrdersFilterParams();
    return (
        <Catcher>
            <ListWrapper
                cleanStore={cleanMonthlyRelationSelectAndStore}
                filterParams={filterParams}
                getRelationSelect={getMonthlyOrdersListRelationSelect}
            >
                <MonthlyOrdersListTable />
            </ListWrapper>
        </Catcher>
    );
};
